import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '@/environments/environment';
import {Extension} from '@/app/core/models/collection/extension';

@Injectable({
	providedIn: 'root'
})
export class ExtensionService {

	private readonly SERVICE_URI = `${environment.backendUrl}/extensions`;

	private readonly http: HttpClient = inject(HttpClient);

	getAllExtensions(): Observable<Extension[]> {
		return this.http.get<Extension[]>(`${this.SERVICE_URI}`);
	}
}
